declare const window: any;

export const Config = {
  app: {
    maintenance: JSON.parse(
      process.env.REACT_APP_MAINTENANCE ||
        (window as any)?.config?.maintenance ||
        "false"
    ),
  },
  debugMode: {
    classicRoles:
      process.env.REACT_APP_DEBUG_MODE_CLASSIC_ROLES ||
      (window as any).config?.debugMode?.classicRoles,
  },
  environment: {
    code:
      process.env.REACT_APP_ENVIRONMENT_CODE ||
      (window as any).config?.environment?.code,
    name:
      process.env.REACT_APP_ENVIRONMENT_NAME ||
      (window as any)?.config?.environment?.name,
    color:
      process.env.REACT_APP_ENVIRONMENT_COLOR ||
      (window as any)?.config?.environment?.color,
  },
  tracking: {
    gtm: process.env.REACT_APP_GTM || (window as any)?.config?.tracking?.gtm,
  },
  msal: {
    connection:
      process.env.REACT_APP_MSAL_CONNECTION ||
      (window as any)?.config?.msal?.connection,
    domain:
      process.env.REACT_APP_MSAL_DOMAIN ||
      (window as any)?.config?.msal?.domain,
    clientId:
      process.env.REACT_APP_MSAL_CLIENT_ID ||
      (window as any)?.config?.msal?.clientId,
  },
  apps: (window as any)?.config?.apps || [],
};
